const urldecode = str =>
  //       discuss at: http://locutus.io/php/urldecode/
  decodeURIComponent(
    `${str}`
      .replace(
        /%(?![\da-f]{2})/gi,
        () =>
          // PHP tolerates poorly formed escape sequences
          '%25',
      )
      .replace(/\+/g, '%20'),
  ).replace(/&amp;/g, '&');

export default urldecode;



// WEBPACK FOOTER //
// ./src/helpers/urldecode.js